
class TagUrl

    constructor: (tagTypes = [], defaults = {}) ->
        @tags = []
        @params = {}
        @extraParamNames = []

        @addTagTypes(tagTypes, defaults)

    Object.defineProperties @prototype,

        queryString: get: ->
            tags = @tags.concat(@extraParamNames)
            tags = "{" + tags.join('}&{') + "}"
            return tags

        allTagTypes: get: ->
            angular.injector(['ng', 'dybTags']).get('TagTypes')

    clone: -> angular.copy(@)

    addExtraParam: (name, config, inUrl=true) ->
        urlName = name
        if angular.isString(config)
            config = value: config, squash: true

        if config.type?
            urlName += ":" + config.type
            delete config.type

        @params[name] = config
        if inUrl then @extraParamNames.push urlName
        return @

    addPagerParams: ->
        @addExtraParam 'page', value: 1, type: 'int', squash: true
        return @

    addSorterParams: (column, direction='asc') ->
        @addExtraParam 'sort', value: column, squash: true
        @addExtraParam 'direction', value: direction, squash: true
        return @

    addTag: (name, defaultValue) ->
        index = @tags.indexOf(name)
        if index == -1
            @tags.push name
            @params[name] = array: true, squash: true
            @setTagDefault name, defaultValue
        return @

    removeTag: (name) =>
        index = @tags.indexOf(name)
        if index >= 0
            @tags.splice(index, 1)
            delete @params[name]
        return @

    setTagDefault: (name, value) ->
        if value?
            value = if angular.isArray(value) then value else [value]
            @params[name]?.value = value
        else
            delete @params[name].value
        return @

    addTagType: (type, defaults = {}) ->
        @addTag(name, defaults[name]) for name in (@allTagTypes[type] or [])
        return  @

    addTagTypes: (types, defaults = {}) ->
        @addTagType(type, defaults) for type in types
        return @

    addDefaults: (params) ->
        for name in @tags
            if not params[name]? and @params[name].value?
                params[name] = @params[name].value
        return

    addEmptyTags: (params) ->
        for name in @tags
            params[name] = params[name] or []
            if params[name].length == 0 and @params[name].value
                params[name] = true
        return

    buildUrl: (baseUrl = '') ->
        sep = if '?' in baseUrl then '&' else '?'
        return baseUrl + sep + @queryString


module.constant 'TagUrl', TagUrl
